{
  "name": "pxc-webapp",
  "version": "7.2.0",
  "engines": {
    "npm": ">=10.0.0",
    "node": ">=22.23.4"
  },
  "packageManager": "pnpm@10.34.5",
  "scripts": {
    "start": "ng serve",
    "build": "ng build && pnpm run transloco:optimize",
    "test": "ng test",
    "test:ci": "ng test --ci --colors --max-workers=50% --coverage --coverage-reporters=cobertura --verbose",
    "e2e": "playwright test",
    "e2e:ci": "playwright test --forbid-only --retries=1 --workers=4",
    "e2e:ui": "playwright test --ui",
    "e2e:typecheck": "tsc -p e2e/tsconfig.json",
    "e2e:install": "playwright install",
    "e2e:codegen": "playwright test --project=setup --reporter=line && playwright codegen --lang=en-US --timezone=Europe/Paris --load-storage=e2e/.auth/user.json",
    "lint": "eslint .",
    "lint:quiet": "eslint . --quiet",
    "lint:fix": "eslint . --fix",
    "format": "prettier --check \"**/*.{ts,html,md}\"",
    "format:fix": "prettier --write \"**/*.{ts,html,md}\"",
    "prepare": "husky",
    "i18n:extract": "transloco-keys-manager extract -d '{{key}}' -l 'fr'",
    "i18n:find": "transloco-keys-manager find",
    "transloco:optimize": "transloco-optimize dist/pxc-webapp/assets/i18n",
    "update-core": "node scripts/update-core.mjs latest",
    "update-core:next": "node scripts/update-core.mjs next"
  },
  "lint-staged": {
    "*.{ts,html}": [
      "eslint --fix --no-warn-ignored",
      "prettier --write"
    ],
    "*.md": "prettier --write"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "22.2.5",
    "@angular/common": "22.2.4",
    "@angular/compiler": "22.2.4",
    "@angular/core": "22.2.4",
    "@angular/fire": "20.0.1",
    "@angular/forms": "22.2.4",
    "@angular/platform-browser": "22.2.4",
    "@angular/platform-browser-dynamic": "22.2.4",
    "@angular/router": "22.2.4",
    "@jsverse/transloco": "8.4.0",
    "@jsverse/transloco-keys-manager": "8.1.0",
    "@jsverse/transloco-messageformat": "8.4.0",
    "@jsverse/transloco-persist-lang": "8.4.0",
    "@jsverse/transloco-utils": "8.4.0",
    "@maskito/angular": "5.6.0",
    "@maskito/core": "5.6.0",
    "@maskito/kit": "5.6.0",
    "@maskito/phone": "5.6.0",
    "@microsoft/applicationinsights-web": "3.4.3",
    "@ng-web-apis/common": "5.4.0",
    "@ng-web-apis/intersection-observer": "5.4.0",
    "@ng-web-apis/mutation-observer": "5.4.0",
    "@ng-web-apis/platform": "5.4.0",
    "@ng-web-apis/resize-observer": "5.4.0",
    "@ng-web-apis/screen-orientation": "5.4.0",
    "@ngneat/until-destroy": "10.0.0",
    "@ngrx/effects": "22.0.1",
    "@ngrx/router-store": "22.0.1",
    "@ngrx/store": "22.0.1",
    "@ngrx/store-devtools": "22.0.1",
    "@pixacare/charts": "6.2.2",
    "@pixacare/chat": "6.2.2",
    "@pixacare/design": "0.4.2",
    "@pixacare/domain": "6.2.2",
    "@pixacare/dressfit": "0.7.5",
    "@pixacare/dressfit-angular": "1.0.0-next.0",
    "@pixacare/dtos": "6.2.2",
    "@pixacare/file-upload": "4.0.0",
    "@pixacare/forms": "7.3.0",
    "@pixacare/forms-angular": "11.0.0-next.1",
    "@pixacare/geometry": "6.2.2",
    "@pixacare/i18n": "0.2.0-next.0",
    "@pixacare/shared": "6.1.3",
    "@pixacare/topocare-core": "0.0.30",
    "@pixacare/topocare-web": "0.0.30",
    "@taiga-ui/addon-commerce": "5.27.0",
    "@taiga-ui/addon-table": "5.27.0",
    "@taiga-ui/cdk": "5.27.0",
    "@taiga-ui/core": "5.27.0",
    "@taiga-ui/design-tokens": "0.324.0",
    "@taiga-ui/event-plugins": "5.1.0",
    "@taiga-ui/experimental": "5.27.0",
    "@taiga-ui/font-watcher": "0.6.0",
    "@taiga-ui/i18n": "5.27.0",
    "@taiga-ui/icons": "5.27.0",
    "@taiga-ui/kit": "5.27.0",
    "@taiga-ui/layout": "5.27.0",
    "@taiga-ui/polymorpheus": "5.0.1",
    "@taiga-ui/styles": "5.27.0",
    "@videogular/ngx-videogular": "20.0.0",
    "ajv-formats": "3.0.1",
    "chart.js": "4.5.1",
    "chartjs-adapter-date-fns": "3.0.0",
    "core-js": "3.49.0",
    "date-fns": "4.4.0",
    "dompurify": "3.4.12",
    "hls.js": "1.6.16",
    "html-to-image": "1.11.11",
    "jest-environment-jsdom": "30.4.1",
    "jest-html-reporters": "3.1.7",
    "jsdom": "29.1.1",
    "jwt-decode": "4.0.0",
    "konva": "10.3.0",
    "libphonenumber-js": "1.13.9",
    "lottie-web": "5.13.0",
    "ng2-charts": "10.0.0",
    "ngx-lottie": "22.0.0",
    "rxjs": "7.8.2",
    "tailwindcss": "4.3.3",
    "ts-cacheable": "1.0.19",
    "tslib": "2.8.1",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@angular-builders/jest": "22.0.1",
    "@angular-devkit/core": "22.2.5",
    "@angular-devkit/schematics": "22.2.5",
    "@angular-eslint/builder": "22.6.0",
    "@angular-eslint/eslint-plugin": "22.6.0",
    "@angular-eslint/eslint-plugin-template": "22.6.0",
    "@angular-eslint/schematics": "22.6.0",
    "@angular-eslint/template-parser": "22.6.0",
    "@angular/build": "22.2.5",
    "@angular/cli": "22.2.5",
    "@angular/compiler-cli": "22.2.4",
    "@angular/language-service": "22.2.4",
    "@eslint/js": "9.39.5",
    "@jest/globals": "30.4.1",
    "@jsverse/transloco-optimize": "8.4.0",
    "@jsverse/transloco-validator": "8.4.0",
    "@ng-web-apis/universal": "2.1.0",
    "@ngrx/schematics": "22.0.1",
    "@playwright/test": "1.61.1",
    "@tailwindcss/postcss": "4.3.3",
    "@testing-library/angular": "19.6.0",
    "@testing-library/dom": "10.4.1",
    "@testing-library/jest-dom": "6.9.1",
    "@testing-library/user-event": "14.6.1",
    "@types/jest": "30.0.0",
    "@types/node": "25.9.5",
    "angular-eslint": "22.6.0",
    "autoprefixer": "10.5.4",
    "base-64": "1.0.0",
    "eslint": "9.39.5",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-only-warn": "1.2.1",
    "eslint-plugin-prettier": "5.5.6",
    "husky": "9.1.7",
    "jasmine-spec-reporter": "7.0.0",
    "jest": "30.4.2",
    "jest-preset-angular": "17.0.3",
    "lint-staged": "16.4.0",
    "mathjs": "15.2.0",
    "postcss": "8.5.20",
    "prettier": "3.9.5",
    "prettier-plugin-tailwindcss": "0.8.1",
    "tw-animate-css": "1.4.0",
    "typescript": "6.0.3",
    "typescript-eslint": "8.64.0",
    "utf8": "3.0.0"
  },
  "alias": {
    "@directives/*": "./src/app/directives/$1",
    "@guards/*": "./src/app/guards/$1",
    "@helpers/*": "./src/app/helpers/$1",
    "@modules/*": "./src/app/modules/$1",
    "@services/*": "./src/app/services/$1",
    "@shared/*": "./src/app/shared/$1"
  }
}
